import * as usersSlice from '../Auth/userSlice'
import * as authSlice from '../Auth/authSlice'
import * as vidSdkSlice from '../VideoSdkAuth/videoSdkAuthSlice'
import * as clientMeetingSlice from '../MeetingsList/clientMeetingsSlice'
import * as providerMeetingSlice from '../MeetingsList/providerMeetingSlice'
import * as meetingTemplateSlice from '../MeetingsList/meetingTemplateSlice'

/** Declaring files here ensures that all slice enhanceEndpoint method calls have run on app init */
export const enhanceEndpoints = () => {
  // This doesn't actually run... it's here so that the slice files don't get tree shaken and enhanceEndpoints gets called
  const enhancements = [
    authSlice,
    usersSlice,
    vidSdkSlice,
    clientMeetingSlice,
    providerMeetingSlice,
    meetingTemplateSlice,
  ]
}
